import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

jQuery(document).ready(function($) {

  // メインビジュアルスライダー
  if($('#homeMvSlider').length) {
    const homeMvSlider = new Splide('#homeMvSlider', {
      type: 'fade',
      rewind: true,
      autoplay: true,
      interval: 5000,
      speed: 1000,
      arrows: false,
      pagination: false,
      pauseOnHover: true,
      pauseOnFocus: true,
    });

    homeMvSlider.mount();
  }

  // Splide AutoScroll Slider
  $(document).ready(function() {
    if($('#autoScrollSlider').length) {
      const autoScrollSlider = new Splide('#autoScrollSlider', {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        gap: '20px',
        arrows: false,
        pagination: false,
        autoScroll: {
          speed: 1,
          pauseOnHover: false,
          pauseOnFocus: false,
          resetProgress: false,
        },
        breakpoints: {
          768: {
            perPage: 1,
            padding: '25%',
            gap: '10px',
          },
        }
      });

      autoScrollSlider.mount({ AutoScroll });
    }
  });

});
